import React from 'react';

interface JiraChamadoBadgeProps {
  chamado?: string | null;
  className?: string;
}

// Número do chamado do Jira (ex.: SUS-1234), exibido ao lado do ID da GMUD
const JiraChamadoBadge: React.FC<JiraChamadoBadgeProps> = ({ chamado, className = '' }) => {
  if (!chamado) return null;

  return (
    <span
      className={`inline-flex items-center rounded-md bg-blue-50 px-2 py-0.5 font-mono text-xs font-semibold text-blue-700 ${className}`}
      title={`Chamado Jira ${chamado}`}
    >
      {chamado}
    </span>
  );
};

export default JiraChamadoBadge;
